import React, {useState, useEffect} from "react";
import ProductCategory from "../components/PorductCategory";
import "../PageCss/Product.css";
import { useAappContext } from "../context/AppContext";
import ProductS from "../components/ProductS";
import ProductGroup from "../components/ProductGroup";
import ploader from '../assest/loading/Settings.gif';
import { useParams } from "react-router-dom";

export  const CategoryProducts = (profs) =>{
    const{ isLoading, products,GetID,GetName,ScategoryId,ScategoryName} = useAappContext();
    const Ploader =ploader;
    const {category} = useParams();

    const [currentPage, setCurrentPage] = useState(1);
    const productsPerPage = 12; // You can change this number
    
    const categoryProducts=products.filter((curProducts)=>{
      return (
      curProducts.product_Category === GetID || 
      curProducts.product_Subcategory === ScategoryId
      );
    });

    const indexOfLastProduct = currentPage * productsPerPage;
    const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
    const currentProducts = categoryProducts.slice(indexOfFirstProduct, indexOfLastProduct);
    const totalPages = Math.ceil(categoryProducts.length / productsPerPage);




    const [Fixing, setFixingNavbar] = useState(false)
        useEffect(() => {
           window.addEventListener('scroll',()=>{
            var scroll_position = window.scrollY;
            if(scroll_position >450){
             setFixingNavbar(!Fixing)
            }else{
              setFixingNavbar(false)  
            }
             })
        },[])

    if(isLoading){
      return <div style={{
        minHeight:400,
        display:'flex',
        justifyContent:"center",
        alignItems:"center",
        fontSize:18,
        color:"green"
      }}> <img src={Ploader} alt="page-loading" /> </div>
    }






    return(
        <>
        <ProductCategory />
        <section id="productsSection" className="section-p1 section-m1">
        
        <div id="page-title" className="title-red">
        <span>{GetName}</span>
        <br />

        <h3 className="section-title-1" 
        style={{
          fontSize:16,
          fontStyle:"italic",
          letterSpacing:2,
          textTransform:"capitalize",
          margin:'2px 20px',
          color:"green"
        }}>
          {ScategoryName}
          </h3>
</div>
            <br/>
            <div className="container">
            <div className='main-produc-group-container'>
                <div className={`main-produc-group-header`}>
                  <h3>main product group </h3>
                </div>
                <ProductGroup/>
              </div>
              <div className= 'productContaner'>
              {
                  currentProducts.map((curElem)=>{
                    const {id:creentpid, product_Category:category,product_Subcategory:subcategory} = curElem;
                      return (
                        <div key={creentpid}>
                        <ProductS key={creentpid} {...curElem} />  
                        </div>
                      ) 
                      
                  })
                }

            </div>


            </div>
            {/* Pagination Controls */}
   <div className="pagination-controls">
          <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1}>
            Prev
          </button>
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentPage(index + 1)}
              className={currentPage === index + 1 ? 'active' : ''}
            >
              {index + 1}
            </button>
          ))}
          <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}>
            Next
          </button>
        </div>

        </section>        
        </>
    )
} 